import * as React from "react";
import { FormError } from "app/shared/model/Form";

export const FormErrorsContext = React.createContext<FormError[] | null>(null);
export const FormErrorsProvider = FormErrorsContext.Provider;